import { IconTextTag } from '@travel/ui';

import styles from './roomInfo.module.scss';

type Props = {
  isPc: boolean;
};

const RoomInfoSkeleton = (props: Props) => {
  const { isPc } = props;

  return (
    <div className={styles.planInformation}>
      <div className={styles.mainInformation}>
        <IconTextTag haveBorder isEmpty className={styles.tag} />
        {isPc && (
          <>
            <IconTextTag haveBorder isEmpty className={styles.tag} />
            <IconTextTag haveBorder isEmpty className={styles.tag} />
          </>
        )}
        <div className={styles.planSkeleton} />
      </div>
      {isPc && <div className={styles.pcImage} />}
    </div>
  );
};

export default RoomInfoSkeleton;
